import React from 'react';
import BasicTable2 from '../tools/BasicTable2';
import IconButton from '@mui/material/IconButton';
import Button from '@mui/material/Button';
import Delete from '@mui/icons-material/Delete'
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import {Divider, FormControl,InputLabel,MenuItem,Select} from '@mui/material';
import Chip from '@mui/material/Chip';
import * as ETVConstants from '../ETVConstants';
import { Add, Save } from '@mui/icons-material';
import ScheduleIcon from '@mui/icons-material/Schedule'
import Schedule from '../tools/MuiSchedulePicker';
import { LinearProgress } from '@mui/material';
import MessageDialog from '../tools/MessageDialog';
import IntercomGapDisplay from './IntercomGapDisplay';

class IntercomAssignmentDialog extends React.Component {

    state = {
      	isLoaded: false,
		isLoading: false,
      	list: [],
		users: [],
		selected_user_id:undefined,
		scheduleObj: { mode: 'daily', daily: [{ start: '00:00', end: '23:59' }], weekly: {} },
    }

    componentDidMount() {
		this.loadAssignments();
    }

	componentDidUpdate() {
		if(!this.state.isLoaded && !this.state.isLoading) {
			this.loadAssignments();
		}
	}

	normalizeSchedule = (sched) => {
		if (sched == null) return null;
		// if backend sends string
		if (typeof sched === 'string') {
			const s = sched.trim();
			if (!s || s === '{}' || s === 'null' || s === 'undefined') return null;
			try { sched = JSON.parse(s); } catch { return null; }
		}
		// if backend wraps it: { schedule: ... } (string or object)
		if (sched && typeof sched === 'object' && sched.schedule != null) {
			return this.normalizeSchedule(sched.schedule);
		}
		// already object
		if (sched && typeof sched === 'object') {
			// ignore empty objects
			if (!this.hasAnySlot(sched)) return null;
			return sched;
		}

		return null;
	};

	hasAnySlot = (sch) => {
		if (!sch || typeof sch !== 'object') return false;

		const dailyOk =
			Array.isArray(sch.daily) &&
			sch.daily.some(seg => seg && typeof seg.start === 'string' && typeof seg.end === 'string');

		const weeklyOk =
			sch.weekly && typeof sch.weekly === 'object' &&
			Object.values(sch.weekly).some(arr =>
			Array.isArray(arr) &&
			arr.some(seg => seg && typeof seg.start === 'string' && typeof seg.end === 'string')
			);

		return dailyOk || weeklyOk;
	};	

	loadAssignments() {
		this.setState({isLoading:true});
		var accessToken = localStorage.getItem("etv.access_token");
		var reqUserID = localStorage.getItem("etv.user_id");
		var urlStr = ETVConstants.getServerBase()+"/intercom_admin?action=list_device_user&device_id="+this.props.device_id;
		fetch(urlStr,{ headers: { 'user_id':reqUserID, 'access_token': accessToken }})
		.then(res => res.json())
		.then(
			(result) => {
				console.log(JSON.stringify(result.list));
				this.setState({
					list:result.list,
					users:this.filterAssignedUsers(result.list),
					isLoaded:true,
					isLoading:false,
				});
			},
			(error) => {
				this.setState({
					isLoaded:true,
					isLoading:false,
				});
			}
		)
	}

	filterAssignedUsers(userList) {
		const all_users = this.props.all_users || [];
		const res = [];
		for (let i = 0; i < all_users.length; i++) {
			const u = all_users[i];
			if (!this.listHasIntercomUser(userList, u.intercom_user_id)) {
			res.push(u);
			}
		}
		return res;
	}

	listHasIntercomUser(userList, intercomUserID) {
		const id = String(intercomUserID);
		return (userList || []).some(u => String(u.intercom_user_id) === id);
	}

	showWindow(divID, show) {
		show?this.setState({window:divID}):this.setState({window:''});
	}

	saveAssignment( userID, priority ) {
		var accessToken = localStorage.getItem("etv.access_token");
		var reqUserID = localStorage.getItem("etv.user_id");
		var urlStr = ETVConstants.getServerBase()+"/intercom_admin?action=assign_device_user&device_id="+this.props.device_id;
		urlStr+="&intercom_user_id="+userID;
		urlStr+="&priority="+priority;
		urlStr+="&schedule={}";
		fetch(urlStr,{ headers: { 'user_id':reqUserID, 'access_token': accessToken }})
		.then(res => res.json())
		.then(
			(result) => {
				this.setState({isLoaded:false});
			},
			(error) => {
				
			}
		)
	}

	saveSchedule() {
		var accessToken = localStorage.getItem("etv.access_token");
		var reqUserID = localStorage.getItem("etv.user_id");
		var urlStr = ETVConstants.getServerBase()+"/intercom_admin?action=set_schedule&device_id="+this.props.device_id;
		urlStr+="&intercom_user_id="+this.state.selected_user_id;
		urlStr+="&schedule="+encodeURIComponent(JSON.stringify(this.state.scheduleObj));
		console.log("url="+urlStr);
		fetch(urlStr,{ headers: { 'user_id':reqUserID, 'access_token': accessToken }})
		.then(res => res.json())
		.then(
			(result) => {
				console.log(JSON.stringify(result));
				this.setState({isLoaded:false, scheduleObj:{}});
			},
			(error) => {
			}
		)
	}	

	deleteAssignment( userID ) {
		var accessToken = localStorage.getItem("etv.access_token");
		var reqUserID = localStorage.getItem("etv.user_id");
		var urlStr = ETVConstants.getServerBase()+"/intercom_admin?action=delete_assignment&device_id="+this.props.device_id;
		urlStr+="&intercom_user_id="+userID;
		fetch(urlStr,{ headers: { 'user_id':reqUserID, 'access_token': accessToken }})
		.then(res => res.json())
		.then(
			(result) => {
				console.log(JSON.stringify(result));
				this.setState({isLoaded:false});
			},
			(error) => {
				
			}
		)
	}

	getUserSchedule(intercomUserID) {
		for (let i = 0; i < this.state.list.length; i++) {
			if (String(this.state.list[i].intercom_user_id) === String(intercomUserID)) {
			return this.normalizeSchedule(this.state.list[i].schedule) || {};
			}
		}
		return {};
	}
	
	getAllUserSchedules() {
		const { list } = this.state;
		if (!Array.isArray(list)) return [];

		const res = [];
		for (let i = 0; i < list.length; i++) {
			const raw = list[i]?.schedule;
			const sch = this.normalizeSchedule(raw);
			if (sch) res.push(sch);
		}
		console.log("RAW schedules from backend:", list.map(x => x?.schedule));
		return res;
	}

	// Schedules format supported (per your app):
	// {
	//   mode: 'daily' | 'weekly',
	//   daily: [{ start: '09:00', end: '18:00' }, ...],         // applies to every day
	//   weekly: { mon: [{start,end},...], tue:[...], ... }      // day-specific
	// }
	//
	// Pass an array of such objects: const result = getCoverageGaps(userSchedules)

	getCoverageGaps(schedules) {
		const DAYS = ['mon','tue','wed','thu','fri','sat','sun'];

		const toMin = (hhmm) => {
			const s = String(hhmm).trim();
			if (s === '24:00') return 1440;

			const [hStr, mStr] = s.split(':');
			const h = Number(hStr);
			const m = Number(mStr);

			if (!Number.isFinite(h) || !Number.isFinite(m)) return null;
			if (h < 0 || h > 24) return null;
			if (m < 0 || m > 59) return null;
			if (h === 24 && m !== 0) return null; // only 24:00 allowed

			return h * 60 + m;
		};

		const addInterval = (arr, startStr, endStr) => {
			if (startStr == null || endStr == null) return;

			const start = String(startStr).trim();
			const end   = String(endStr).trim();

			// exact full day markers
			if (start === '00:00' && (end === '00:00' || end === '24:00')) {
				arr.push([0, 1440]);
				return;
			}

			let s = toMin(start);
			let e = toMin(end);

			if (s == null || e == null) return;

			// treat "...–00:00" as "...–24:00" (end of day) unless it's 00:00–00:00
			if (end === '00:00' && start !== '00:00') e = 1440;

			if (s < e) {
				arr.push([s, e]);
			} else if (s > e) {
				// wrap over midnight, but note: e can be 1440, so wrapping only makes sense if e < 1440
				if (e === 1440) {
				arr.push([s, 1440]);
				} else {
				arr.push([s, 1440], [0, e]);
				}
			} else {
				// same time but NOT a full-day marker => ignore
			}
		};

		const mergeIntervals = (intervals) => {
			const clean = (intervals || []).filter(x => Array.isArray(x) && x.length === 2);
			if (!clean.length) return [];
			clean.sort((a,b) => a[0]-b[0] || a[1]-b[1]);
			const out = [clean[0].slice()];
			for (let i=1;i<clean.length;i++) {
				const [s,e] = clean[i];
				const last = out[out.length-1];
				if (s <= last[1]) last[1] = Math.max(last[1], e);
				else out.push([s,e]);
			}
			return out;
		};

		const toHHMM = (min) => {
			if (min == null) return '00:00';
			if (min >= 1440) return '24:00';

			const h = Math.floor(min / 60);
			const m = min % 60;
			return `${String(h).padStart(2,'0')}:${String(m).padStart(2,'0')}`;
		};

		// Build intervals per day from all schedules
		const dayIntervals = Object.fromEntries(DAYS.map(d => [d, []]));

		for (const sch of schedules || []) {
			if (!sch || typeof sch !== 'object') continue;

			// daily -> apply to all days
			if (Array.isArray(sch.daily)) {
			for (const seg of sch.daily) {
				for (const d of DAYS) addInterval(dayIntervals[d], seg?.start, seg?.end);
			}
			}

			// weekly -> apply per provided day
			if (sch.weekly && typeof sch.weekly === 'object') {
			for (const d of DAYS) {
				const slots = sch.weekly[d] || [];
				for (const seg of slots) addInterval(dayIntervals[d], seg?.start, seg?.end);
			}
			}
		}

		// Compute uncovered gaps per day
		const gaps = [];
		for (const d of DAYS) {
			const merged = mergeIntervals(dayIntervals[d]);
			let cursor = 0;
			for (const [s,e] of merged) {
			if (s > cursor) gaps.push({ day: d, start: toHHMM(cursor), end: toHHMM(s) });
			cursor = Math.max(cursor, e);
			}
			if (cursor < 1440) gaps.push({ day: d, start: toHHMM(cursor), end: '24:00' });
		}

		return {
			covered: gaps.length === 0,
			gaps // e.g. [{day:'mon', start:'00:00', end:'08:59'}, ...]
		};
	}


////////////////////////////////////////////////////////////////////////////////
// 
////////////////////////////////////////////////////////////////////////////////

    render() {
		const columnsData= [
			{ title: ETVConstants.trans("intercom_user"), field: 'user_name'},
			{
			title: ETVConstants.trans("priority") || "Priority",
			field: "priority",
			render: (rowData) => {
				const value = Number(rowData.priority);
				let label = "";
				let color = "";

				if (value === 0) {
				label = ETVConstants.trans("main_contact") || "Main contact";
				color = "#1b5e20"; // dark green
				} else if (value === 1) {
				label = ETVConstants.trans("backup_contact") || "Backup contact";
				color = "#b71c1c"; // dark red
				} else {
				label = ETVConstants.trans("other") || "Other";
				color = "#616161"; // grey
				}

				return (
				<Chip
					label={label}
					size="small"
					sx={{
					backgroundColor: color,
					color: "white",
					fontWeight: 500,
					}}
				/>
				);
			},
			},
			{ title: ETVConstants.trans("schedule"), field: '', render: rowData => <div style={{width:5}}><IconButton size='small' label='edit' variant='contained' color='primary' onClick={()=>this.setState({window:'set_schedule_div',selected_user_id:rowData.intercom_user_id,scheduleObj:this.getUserSchedule(rowData.intercom_user_id)})}><ScheduleIcon/></IconButton></div>},
			{ title: ETVConstants.trans("delete"), field: 'delete', render: rowData => <div style={{width:5}}><IconButton size='small' label='delete' variant='contained' color='error' onClick={()=>this.deleteAssignment(rowData.intercom_user_id)}><Delete/></IconButton></div>},
        ];

		var allSchedules = this.getAllUserSchedules();
		console.log("all_schedules="+JSON.stringify(allSchedules));
		var gaps = this.getCoverageGaps(allSchedules);
		console.log("GAPS="+JSON.stringify(gaps));

	    return(
			<div>
				{this.state.isLoading && <LinearProgress/>}
				<BasicTable2 data={this.state.list} columns={columnsData} title={""} pageSize={5} allow_search={true} />
				<Button style={{marginTop:20}} variant='contained' startIcon={<Add/>} onClick={()=>{this.setState({window:'add_user_div'})}}>{ETVConstants.trans("add_user")}</Button>
				<Divider style={{marginTop:10, marginBottom:10}} />
				<IntercomGapDisplay gaps={gaps}/>

				<MessageDialog open={this.state.window==='message_div'} spinning={this.state.spinning} onClose={()=>this.closeInfoMessage()} title={this.state.info_title} message={this.state.info_message} type={this.state.info_type} />

				<Dialog
					open={this.state.window === 'add_user_div'}
					maxWidth="xs"
					fullWidth
					onClose={() => this.setState({ window: '' })}
				>
					<DialogTitle id="message div">
						{this.state.info_title || (ETVConstants.trans('assign_user') || 'Assign user')}
					</DialogTitle>

					<DialogContent sx={{ display: 'grid', gap: 2, pt: 1 }}>
						<FormControl fullWidth>
							<InputLabel id="add-user-select-label">
								{ETVConstants.trans('user') || 'User'}
							</InputLabel>
							<Select
								labelId="add-user-select-label"
								label={ETVConstants.trans('user') || 'User'}
								value={this.state.addAssignUserId || ''}
								onChange={(e) =>
									this.setState({ addAssignUserId: String(e.target.value) })
								}
								MenuProps={{ sx: { maxHeight: 360 } }}
							>
								{(this.state.users || []).map((u) => (
								<MenuItem
									key={String(u.intercom_user_id)}
									value={String(u.intercom_user_id)}
								>
									{u.user_name || `user:${u.intercom_user_id}`}
								</MenuItem>
								))}
							</Select>
						</FormControl>

						<FormControl fullWidth>
							<InputLabel id="add-priority-select-label">
								{ETVConstants.trans('priority')}
							</InputLabel>
							<Select
								labelId="add-priority-select-label"
								label={ETVConstants.trans('priority')}
								value={this.state.addAssignPriority}
								onChange={(e) =>
									this.setState({ addAssignPriority: Number(e.target.value) })
								}
							>
								<MenuItem value={0}>{ETVConstants.trans('main_contact')}</MenuItem>
								<MenuItem value={1}>{ETVConstants.trans('backup_contact')}</MenuItem>
							</Select>
						</FormControl>
					</DialogContent>

					<DialogActions>
						<Button onClick={() => this.setState({ window: '' })} color="primary">
						{ETVConstants.trans('close') || 'Close'}
						</Button>
						<Button
							variant="contained"
							startIcon={<Save />}
							disabled={!this.state.addAssignUserId}
							onClick={() => {
								this.saveAssignment(this.state.addAssignUserId, this.state.addAssignPriority);
								this.setState({ window: '' });
							}}
						>
							{ETVConstants.trans('save') || 'Save'}
						</Button>
					</DialogActions>
				</Dialog>

				<Dialog
					open={this.state.window === 'set_schedule_div'}
					maxWidth="md"
					fullWidth
					onClose={() => this.setState({ window: '' })}
				>
					<DialogTitle id="schedule">{ETVConstants.trans('set_schedule')}</DialogTitle>

					<DialogContent sx={{ display: 'grid', gap: 2, pt: 1 }}>
						<Schedule
							value={this.state.scheduleObj}
							onSchedule={(next) => this.setState({ scheduleObj: next })}
							timeStep={1}
							title={ETVConstants.trans('schedule') || 'Schedule'}
						/>
					</DialogContent>

					<DialogActions>
						<Button onClick={() => this.setState({ window: '' })} color="primary">
							{ETVConstants.trans('close') || 'Close'}
						</Button>
						<Button
							variant="contained"
							startIcon={<Save />}
							onClick={() => {
								this.saveSchedule();
								this.setState({ window: '' });
							}}
							>
							{ETVConstants.trans('save') || 'Save'}
						</Button>
					</DialogActions>
				</Dialog>
	        </div>
	   );
	}
}

export default IntercomAssignmentDialog
